import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { confirmDialog } from 'primereact/confirmdialog';

export default function useCancelTestExecution(cancelMutation) {
  const [cancelling, setCancelling] = useState(false);
  const [onCancelTest] = useMutation(cancelMutation);

  const cancel = (id, redirectUrl) => {
    confirmDialog({
      message: 'Are you sure you want to cancel this execution?',
      header: 'Cancel test execution?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        setCancelling(true);

        onCancelTest({ variables: { ids: [id] } })
          .then(() => {
            window.location.href = redirectUrl;
          })
          .catch((e) => {
            alert(`Cancel test execution failed. Error: ${e.message}`);
            setCancelling(false);
          });
      },
    });
  };

  return { cancelling, cancel };
}
